/* ==========================================================================
   DTF CATALOG COLLECTION PAGE JAVASCRIPT
   Instant client-side category search, mobile drawer handling, and auto-submit sorting
   ========================================================================== */

(() => {
  function init(root) {
    if (root.dataset.rcReady) return;
    root.dataset.rcReady = 'true';

    const search = root.querySelector('[data-rc-search]');
    const items = [...root.querySelectorAll('[data-rc-category]')];
    const groups = [...root.querySelectorAll('[data-rc-group]')];
    const noCategories = root.querySelector('[data-rc-no-categories]');
    const statusText = root.querySelector('[data-rc-search-status]');
    const defaults = new Map(groups.map(group => [group, group.open]));

    const normalize = text =>
      text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

    function filterCategories() {
      if (!search) return;
      const terms = normalize(search.value).split(/\s+/).filter(Boolean);
      let count = 0;

      items.forEach(item => {
        const label = normalize(item.dataset.rcCategory || '');
        const matches = terms.every(term => label.includes(term));
        item.hidden = !matches;
        if (matches) count++;
      });

      groups.forEach(group => {
        const hasVisible = [...group.querySelectorAll('[data-rc-category]')].some(item => !item.hidden);
        group.hidden = !hasVisible;
        group.open = terms.length ? true : defaults.get(group);
      });

      if (noCategories) {
        noCategories.hidden = count > 0 || terms.length === 0;
      }
      if (statusText) {
        statusText.textContent = terms.length ? `${count} matching categories` : '';
      }
    }

    search?.addEventListener('input', filterCategories);
    search?.addEventListener('search', filterCategories);

    // Responsive drawer handling
    const drawer = root.querySelector('[data-rc-drawer]');
    const small = window.matchMedia('(max-width: 700px)');
    const updateDrawer = () => {
      if (drawer) {
        drawer.open = !small.matches;
      }
    };
    updateDrawer();

    if (small.addEventListener) {
      small.addEventListener('change', updateDrawer);
    } else if (small.addListener) {
      small.addListener(updateDrawer);
    }

    // Auto-submit on sort dropdown change
    const sortSelect = root.querySelector('[data-rc-sort]');
    sortSelect?.addEventListener('change', event => {
      const form = event.target.form;
      if (form) {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      } else {
        // Fallback: reload with sort_by param
        const url = new URL(location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        location.href = url.href;
      }
    });

    // Cleanup when section unloads in Theme Customizer
    const unload = event => {
      if (!event.target.contains(root)) return;
      if (small.removeEventListener) {
        small.removeEventListener('change', updateDrawer);
      } else if (small.removeListener) {
        small.removeListener(updateDrawer);
      }
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }

  function mountAll() {
    document.querySelectorAll('[data-dtfo-catalog]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  if (!window.dtfoCatalogLoadBound) {
    window.dtfoCatalogLoadBound = true;
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('[data-dtfo-catalog]').forEach(init);
    });
  }
})();
